var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { ref: "searchBox", staticClass: "search-box" },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入销售订单号" },
                model: {
                  value: _vm.condition.orderSn,
                  callback: function ($$v) {
                    _vm.$set(_vm.condition, "orderSn", $$v)
                  },
                  expression: "condition.orderSn",
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入SAP销售订单号" },
                model: {
                  value: _vm.condition.sapSalesOrderSn,
                  callback: function ($$v) {
                    _vm.$set(_vm.condition, "sapSalesOrderSn", $$v)
                  },
                  expression: "condition.sapSalesOrderSn",
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择订单状态" },
                  model: {
                    value: _vm.condition.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "status", $$v)
                    },
                    expression: "condition.status",
                  },
                },
                _vm._l(_vm.statusOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择单据类型" },
                  model: {
                    value: _vm.condition.deliveryType,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "deliveryType", $$v)
                    },
                    expression: "condition.deliveryType",
                  },
                },
                _vm._l(_vm.salesTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.getPage("refresh")
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleEdit(null)
                    },
                  },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "listTable",
          attrs: { data: _vm.tableData, height: _vm.tableHeight, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "订单状态",
              align: "left",
              prop: "status",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status == 1
                      ? _c("span", [_vm._v("制单")])
                      : _vm._e(),
                    scope.row.status == 2
                      ? _c("span", [_vm._v("发货中")])
                      : _vm._e(),
                    scope.row.status == 3
                      ? _c("span", [_vm._v("发货完成")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "单据类型",
              align: "left",
              prop: "deliveryType",
              "show-overflow-tooltip": "",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.deliveryType == 1
                      ? _c("span", [_vm._v("发货单")])
                      : _vm._e(),
                    scope.row.deliveryType == 2
                      ? _c("span", [_vm._v("退货发货单")])
                      : _vm._e(),
                    scope.row.deliveryType == 3
                      ? _c("span", [_vm._v("不定价发货单")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "交货单号",
              align: "left",
              prop: "sn",
              "show-overflow-tooltip": "",
              width: "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "SAP交货单号",
              align: "left",
              prop: "sapDeliverySn",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "SAP调仓单号",
              align: "left",
              prop: "sapTransferOrder",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "销售订单号",
              align: "left",
              prop: "orderSn",
              "show-overflow-tooltip": "",
              width: "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "SAP销售单号",
              align: "left",
              prop: "sapSalesOrderSn",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "售达方代码",
              align: "left",
              prop: "soldToPartyCode",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "售达方",
              align: "left",
              prop: "soldToPartyName",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "送达方代码",
              align: "left",
              prop: "deliverySideCode",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "送达方",
              align: "left",
              prop: "deliverySideName",
              width: "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "调拨日期",
              align: "left",
              prop: "transferDate",
              width: "180",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "实际发货日期",
              align: "left",
              prop: "actualShippingTime",
              width: "180",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建时间",
              align: "left",
              prop: "createTime",
              width: "180",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status <= 2
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row.id, "修改")
                              },
                            },
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row.id, "查看")
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.sapDeliverySn
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.print(scope.row.id)
                              },
                            },
                          },
                          [_vm._v(" 打印 ")]
                        )
                      : _vm._e(),
                    scope.row.status <= 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    scope.row.status === 3
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "deliver:salesOrder:index:del",
                                expression: "'deliver:salesOrder:index:del'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "footer-box" },
        [
          _c("el-col", { attrs: { span: 12 } }),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.total,
                  page: _vm.pagination.current,
                  limit: _vm.pagination.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination, "size", $event)
                  },
                  pagination: _vm.getPage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("edit", {
        ref: "edit",
        attrs: { show: _vm.showEdit, "edit-id": _vm.editId },
        on: { close: _vm.closeEdit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }